import { atom, selector } from "recoil";
import { authorizationQuery } from "./AuthorizationState";

export const contractConfigState = atom({
  key: 'contractConfigState',
  default: selector({
    key: 'contractConfigStateSelector',
    get: ({get}) => {
      const authorization = get(authorizationQuery);
      return {
        mapRegion: authorization.mapConfig.MAP_REGION,
        specificPotekaIds: authorization.specificPotekaIds,
        defaultCameraPackageId: authorization.defaultCameraPackageId
      }
    }
  })
})